module.exports = __webpack_public_path__ + "static/media/IMG_7777_cropped3.02ad9001.jpg";